var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item_sidebar"},[_c('div',{staticClass:"title title_m_b"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"info_message_box"},[_c('p',[_vm._v(_vm._s(_vm.value.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }